/* eslint-disable no-unused-vars */

import xaxios from '@/xaxios';
import gql from 'graphql-tag';

const findModuloPortalID = async (thiz,moduloid) => {
  const sql = gql`query{ getModulo(id:${moduloid}){ id,nombre,sigla,tipo } }`;
  const fmod = await thiz.$apollo.query({ query: sql }).then(({data})=>data).catch((e)=>e);
  if(!fmod) return {}
  return fmod.getModulo;
}

const findModuloPortalName = async (thiz,nombre) => {
  const sql = gql`query{ getModulos(cursor:1000000,nombre:\"${nombre}\"){ id,nombre,sigla,tipo } }`;
  const fmods = await thiz.$apollo.query({ query: sql }).then(({data})=>data).catch((e)=>e);
  if(fmods && fmods.getModulos){
    if(fmods.getModulos.length>0) return fmods.getModulos[0]
  } 
  return {}
}

const createModuloPortal = async (thiz,nombre) => {
  const obj = {
    nombre: nombre,
    sigla: 'MOD-v2',
    tipo: 'NEW',
  }
  const sql = gql`mutation{ createModulo(input:${window.stringifyObject(obj)}){ok,modulo{id,nombre,sigla,tipo},errors{message}} }`;
  const mod = await thiz.$apollo.mutate({ mutation: sql }).then(({data})=>data).catch((e)=>e);
  if(mod && mod.createModulo){
    if(mod.createModulo.ok) return mod.createModulo.modulo
    else{
      window.console.log('errmod', mod);
      
      thiz.$root.$notify.show(mod.createModulo.errors[0].message, { color: 'red', x: 'right' });
      
    }
  }else{
    thiz.$root.$notify.show('error al crear modulo del programa universidad: '+nombre, { color: 'red', x: 'right' });
  }
  return {}
}

export const getModulosProgramaUniversidad = async (thiz,proguniv_id, programa) => {
    const urlmods = process.env.VUE_APP_URL_API_PAGOS2+'modulos-programas-universidades?programaUniversidadId='+proguniv_id;
    const resmods = await xaxios.get(urlmods).then(({data})=>data).catch((e)=>e);
    if(resmods && resmods.datos){
      const modulosunis = resmods.datos
      modulosunis.sort((a,b)=>a.numero - b.numero)

      programa.programa_modulo = []
      window.console.log('modulos_unis',modulosunis);

      // let nuerito = 0
      for(let i=0;i<modulosunis.length;i++){
        const m = modulosunis[i]; 

        let mod = await findModuloPortalName(thiz,m.nombre)
        if(!mod || !mod.id){
          // este registra pero no devuelve el modulo asi que por eso volvemos a buscar
          window.console.log('yaaaaa crear>>>',mod);
          
          await createModuloPortal(thiz,m.nombre)
          mod = await findModuloPortalName(thiz,m.nombre)
        }
        // window.console.log('modddddd', mod);
        
        if(!mod || !mod.id) continue;
        /* const ex = programa.programa_modulo.find(x=>x.modulo_id == mod.id)
        if(ex) continue; */

        const add = {
          modulo_id: mod.id,
          programa_modulo_id: null, //i +1
          // numero: nuerito++,
          numero: m.numero,
          tipo_calificacion: 'Moodle y Sistema',
          fecha_inicio: m.fechaInicio,
          fecha_fin: m.fechaFin,
          xmodulo: mod,
        } 
        
        programa.programa_modulo.push( add );
      }
      // { "modulo_id": 11642, "programa_modulo_id": -1, "numero": "0", "tipo_calificacion": "Moodle y Sistema", "fecha_inicio": "2026-03-01", "fecha_fin": "2026-03-31" } 

      
      return modulosunis
    }
    return []
}

export const createModulosProgramaUniversidad = async (thiz,proguniv_id, programa) => {
  const pms = programa.programa_modulo;
  const urlmods = process.env.VUE_APP_URL_API_PAGOS2+'modulos-programas-universidades';
  for(let i=0; i<pms.length; i++){
    const mod = pms[i]
    const moduloesam = await findModuloPortalID(thiz,mod.modulo_id)
    
    const nuevo = {
      programaUniversidadId: proguniv_id,
      numero: mod.numero,
      cargaHorariaPresencial: 0,
      cargaHorariaNoPresencial: 0,
      fechaInicio: mod.fecha_inicio,
      fechaFin: mod.fecha_fin,
      nombre: moduloesam.nombre,
    }
    const addmods = await xaxios.post(urlmods,nuevo).then(({data})=>data).catch((e)=>e);
    window.console.log('addmods',addmods);
    
  }
}